import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SecretlintApp } from './SecretlintApp.js';

/**
 * @graph-stack repository-secretlint
 * @graph-domain Engineering
 * @graph-business Standalone development entrypoint for the repository-secretlint remote.
 * @graph-connects SecretlintApp [calls] Remote app component
 */

/** @graph-connects none */
const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <SecretlintApp apiBaseUrl="/api" initialPath={window.location.pathname} />
    </StrictMode>,
  );
}
